module.exports = __webpack_public_path__ + "static/media/HINDPETRO.4b82bc10.txt";